declare var resourceUrl: string;
declare var serverUrl: string;

export const environment = {
  production: false,
  mapApiKey: 'AIzaSyAlIhOiTy90nSOl4KtIa2MJl3cM7Xhu_70',
  mapCityRadius: 50,
  authority: 'https://alpha.sso.globalwarranty.net',
  serverUrl: 'https://e2-api-gwc-dev-e5dubcfzeuf4hxed.canadacentral-01.azurewebsites.net/',
  resourceUrl: 'https://gwcresourceapi-api-gwc-dev-c4dqeqgjcuhgfmhm.canadacentral-01.azurewebsites.net/',
  socketUrl: 'https://gwcresourceapi-api-gwc-dev-c4dqeqgjcuhgfmhm.canadacentral-01.azurewebsites.net/',
  messages: {
    apiError: 'An error has occured.  Please contact your administrator.'
  },
  claimsListHighlightRedDaysRangeStart: 3,
  claimsListHighlightRedDaysRangeEnd: 5,
  claimsListHighlightYellowDaysRangeStart: 2,
  claimsListHighlightYellowDaysRangeEnd: 3,
  appVersion: require('../../version.json').version,
  shopLink: 'https://www.shopkey5.com',
  shopLinkLabel: 'Shop Key',
  insurerEmail: "@archinsurance.com",
  insurerDateCutoff: new Date(2022, 3, 1)
};
